import styled from "styled-components";

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
  height: 100%;
  padding: 0 32px 32px 32px;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 16px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 12px 0 0 0;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

export const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
`;

export const NoDataTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
`;

export const NoDataDescription = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors.textSecondary};
  margin: 0;
  text-align: center;
`;
